<template>
<div class="chapter">
<div class="inner_page">
<p class="p10"><b></b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section6.vue?fc49cd54